import React from 'react';
import {View, Text} from '@react-pdf/renderer';
import styles from '../styles';

const ServicesComments = () => {
  return (
    <>
      <View style={[styles.sectionHeader, styles.center]}>
        <Text style={styles.text}>KOMENTE SHTESË</Text>
      </View>
      <View style={styles.contentSection}>
        <Text style={styles.text}> </Text>
      </View>
      <View style={styles.contentSection}>
        <Text style={styles.text}> </Text>
      </View>
      <View style={styles.contentSection}>
        <Text style={styles.text}> </Text>
      </View>
    </>
  );
};

export default ServicesComments;
